import React, { FC, memo } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { colors } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2)
  },
  disclaimerContainerNote: {
    fontWeight: 500,
    letterSpacing: 0.75,
    fontSize: 10
  },
  disclaimerContainer: {
    fontWeight: 500,
    letterSpacing: 0.75,
    fontSize: 12,
    color: colors.error
  },
  scammers: {
    fontWeight: 700,
    fontSize: 14,
    paddingBottom:'1em'
  }
}));

const Component: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        className={clsx(classes.disclaimerContainer, classes.scammers)}
      >
        BEWARE OF SCAMMERS!!! ONLY TRANSACT THROUGH OUR OFFICIAL FACEBOOK PAGE
        AND LEGITIMATE CONTACT NUMBERS PROVIDED ABOVE
      </Typography>
      <Typography className={classes.disclaimerContainerNote}>
        NOTE: THIS QUOTATION IS NOT A CONTRACT OR A BILL. IT IS OUR BEST GUESS
        AT THE TOTAL PRICE FOR THE SERVICE AND GOODS DESCRIBED ABOVE. THE
        CUSTOMER WILL BE BILLED AFTER INDICATING ACCEPTANCE OF THIS QUOTE.
        PAYMENT WILL BE DUE PRIOR TO THE DELIVERY OF SERVICE AND GOODS. PRICE
        ARE SUBJECT TO CHANGE WITHOUT ANY PRIOR NOTICE / SHIPPING FEES NOT YET
        INCLUDED
      </Typography>
    </div>
  );
};

export const QuotationFooterNote = memo(Component);
